/*
 * Funnel Video Hero
 * - Custom HTML5 video player (play/pause, progress, time, volume, speed, quality, fullscreen)
 * - CTA reveal: time-based, exit-intent, or both
 */
(function () {
  function formatTime(sec) {
    if (!isFinite(sec) || sec < 0) sec = 0;
    var m = Math.floor(sec / 60);
    var s = Math.floor(sec % 60);
    return m + ':' + (s < 10 ? '0' + s : s);
  }

  function init(root) {
    if (root.__funnelVideoHeroInit) return;
    root.__funnelVideoHeroInit = true;

    var configEl = document.getElementById(root.dataset.configId);
    var config = { cta: { trigger: 'time', delaySeconds: 30, startTimerOnFirstPlay: true, exitIntentMobileFallback: true } };
    if (configEl) {
      try { config = JSON.parse(configEl.textContent); }
      catch (e) { console.warn('[funnel-video-hero] config parse error', e); }
    }

    var playerEl  = root.querySelector('[data-fvh-player]');
    var video     = root.querySelector('[data-fvh-video]');
    var bigPlay   = root.querySelector('[data-fvh-big-play]');
    var controls  = root.querySelector('[data-fvh-controls]');
    var progress  = root.querySelector('[data-fvh-progress]');
    var bar       = root.querySelector('[data-fvh-bar]');
    var buffer    = root.querySelector('[data-fvh-buffer]');
    var handle    = root.querySelector('[data-fvh-handle]');
    var playBtn   = root.querySelector('[data-fvh-play]');
    var muteBtn   = root.querySelector('[data-fvh-mute]');
    var volumeWrap = root.querySelector('[data-fvh-volume-wrap]');
    var volTrack  = root.querySelector('[data-fvh-volume-slider]');
    var volFill   = root.querySelector('[data-fvh-volume-fill]');
    var settingsWrap = root.querySelector('[data-fvh-settings-wrap]');
    var settingsToggle = root.querySelector('[data-fvh-settings-toggle]');
    var settingsMenu = root.querySelector('[data-fvh-settings-menu]');
    var speedOptions = root.querySelector('[data-fvh-speed-options]');
    var qualityOptions = root.querySelector('[data-fvh-quality-options]');
    var fsBtn     = root.querySelector('[data-fvh-fullscreen]');
    var currentEl = root.querySelector('[data-fvh-current]');
    var durationEl = root.querySelector('[data-fvh-duration]');
    var cta       = root.querySelector('[data-fvh-cta]');

    if (!playerEl || !video) return;

    /* ---------- HLS (Cloudflare Stream etc.) ---------- */
    var hlsInstance = null;
    var manualQuality = false;
    var hlsUrl = video.getAttribute('data-fvh-hls');
    if (hlsUrl) setupHls(hlsUrl);

    function setupHls(src) {
      // Safari / iOS play HLS natively — no JS lib needed
      if (video.canPlayType('application/vnd.apple.mpegurl')) {
        video.src = src;
        hideQualityGroup(); // native HLS exposes no level switcher here
        return;
      }
      if (window.Hls && window.Hls.isSupported()) {
        hlsInstance = new window.Hls({
          // Open in HD instead of crawling up from 240p. hls.js derives the
          // start level from this estimate; the old 3 Mbit/s value started the
          // ABR at the very bottom, so the make-or-break first seconds looked
          // terrible. Real measured bandwidth takes over after the first few
          // segments, so genuinely slow connections still adapt down.
          abrEwmaDefaultEstimate: 12000000,
          // NEVER cap quality to the rendered player size. A previous build set
          // this to true, which pinned quality to the LOWEST level because the
          // player measures as 0px at init. Do not reintroduce.
          capLevelToPlayerSize: false,
          // Climb back to higher renditions a little more eagerly after a drop.
          abrBandWidthUpFactor: 0.85
        });
        hlsInstance.loadSource(src);
        hlsInstance.attachMedia(video);
        hlsInstance.on(window.Hls.Events.MANIFEST_PARSED, function () {
          // Hint the highest-resolution rendition as the starting point (this is
          // the existing, always-on behaviour).
          var levels = hlsInstance.levels || [];
          if (levels.length > 1) {
            var best = 0;
            for (var i = 1; i < levels.length; i++) {
              if ((levels[i].height || 0) > (levels[best].height || 0)) best = i;
            }
            hlsInstance.startLevel = best;

            // Opt-in per section (config.forceHdStart): startLevel alone wasn't
            // enough with some manifests — hls.js had already committed the first
            // fragment on an ABR-chosen level. So PIN currentLevel to the top for
            // the opening frames, then hand back to auto once a little buffer
            // exists (slow lines still adapt down). Off = section behaves exactly
            // as before, only the startLevel hint above applies.
            if (config.forceHdStart) {
              hlsInstance.currentLevel = best;

              var releaseTimer = null;
              var fragCount = 0;
              var releaseToAuto = function () {
                hlsInstance.off(window.Hls.Events.FRAG_BUFFERED, onFragBuffered);
                if (releaseTimer) { clearTimeout(releaseTimer); releaseTimer = null; }
                if (!manualQuality) hlsInstance.currentLevel = -1; // re-enable ABR
              };
              var onFragBuffered = function () { if (++fragCount >= 2) releaseToAuto(); };
              hlsInstance.on(window.Hls.Events.FRAG_BUFFERED, onFragBuffered);
              releaseTimer = setTimeout(releaseToAuto, 12000);
            }
          }
          populateHlsQuality(hlsInstance);
        });
        hlsInstance.on(window.Hls.Events.ERROR, function (evt, data) {
          if (!data || !data.fatal) return;
          if (data.type === window.Hls.ErrorTypes.NETWORK_ERROR) hlsInstance.startLoad();
          else if (data.type === window.Hls.ErrorTypes.MEDIA_ERROR) hlsInstance.recoverMediaError();
          else hlsInstance.destroy();
        });
        return;
      }
      // Last resort: let the browser try
      video.src = src;
      hideQualityGroup();
    }

    function hideQualityGroup() {
      var group = root.querySelector('[data-fvh-quality-group]');
      if (group) group.style.display = 'none';
    }

    function populateHlsQuality(hls) {
      if (!qualityOptions) return;
      var heights = [];
      (hls.levels || []).forEach(function (l) {
        if (l.height && heights.indexOf(l.height) === -1) heights.push(l.height);
      });
      heights.sort(function (a, b) { return b - a; });
      if (heights.length <= 1) { hideQualityGroup(); return; }
      var html = '';
      heights.forEach(function (h) {
        html += '<button type="button" data-fvh-quality="' + h + '">' + h + 'p</button>';
      });
      html += '<button type="button" data-fvh-quality="auto" data-active>Auto</button>';
      qualityOptions.innerHTML = html;
    }

    function setHlsQuality(quality) {
      if (!hlsInstance) return;
      if (quality === 'auto') { hlsInstance.currentLevel = -1; return; }
      var h = parseInt(quality, 10);
      for (var i = 0; i < hlsInstance.levels.length; i++) {
        if (hlsInstance.levels[i].height === h) { hlsInstance.currentLevel = i; return; }
      }
    }

    var hideControlsTimer = null;
    var ctaShown = false;
    var firstPlayHappened = false;
    var pageLoadTime = Date.now();
    var firstPlayTime = null;

    /* ---------- Helpers ---------- */
    function showControls() {
      playerEl.classList.add('is-controls-visible');
      if (hideControlsTimer) clearTimeout(hideControlsTimer);
      if (!video.paused && !video.ended) {
        hideControlsTimer = setTimeout(function () {
          playerEl.classList.remove('is-controls-visible');
        }, 2800);
      }
    }

    function setStarted() {
      if (playerEl.classList.contains('is-started')) return;
      playerEl.classList.add('is-started');
      controls.setAttribute('aria-hidden', 'false');
    }

    /* ---------- Play / Pause ---------- */
    function play() { video.play().catch(function () { /* autoplay blocked */ }); }
    function pause() { video.pause(); }
    function toggle() { video.paused ? play() : pause(); }

    if (bigPlay) bigPlay.addEventListener('click', function () { setStarted(); play(); });
    if (playBtn) playBtn.addEventListener('click', toggle);
    video.addEventListener('click', function () {
      if (playerEl.classList.contains('is-started')) toggle();
    });

    video.addEventListener('play', function () {
      playerEl.classList.add('is-playing');
      setStarted();
      showControls();
      if (!firstPlayHappened) {
        firstPlayHappened = true;
        firstPlayTime = Date.now();
        scheduleCtaTimer();
      }
    });
    video.addEventListener('pause', function () {
      playerEl.classList.remove('is-playing');
      playerEl.classList.add('is-controls-visible');
      if (hideControlsTimer) clearTimeout(hideControlsTimer);
    });
    video.addEventListener('ended', function () {
      playerEl.classList.remove('is-playing');
      playerEl.classList.add('is-controls-visible');
    });

    /* ---------- Time / Progress ---------- */
    video.addEventListener('loadedmetadata', function () {
      if (durationEl) durationEl.textContent = formatTime(video.duration);
    });
    video.addEventListener('timeupdate', function () {
      if (!video.duration) return;
      var pct = (video.currentTime / video.duration) * 100;
      if (bar)    bar.style.width = pct + '%';
      if (handle) handle.style.left = pct + '%';
      if (currentEl) currentEl.textContent = formatTime(video.currentTime);
    });
    video.addEventListener('progress', function () {
      try {
        if (video.buffered && video.buffered.length && video.duration) {
          var end = video.buffered.end(video.buffered.length - 1);
          var pct = (end / video.duration) * 100;
          if (buffer) buffer.style.width = pct + '%';
        }
      } catch (e) {}
    });

    function seekFromEvent(e) {
      var rect = progress.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      var pct = Math.min(1, Math.max(0, x / rect.width));
      if (video.duration) video.currentTime = pct * video.duration;
    }
    if (progress) {
      var seeking = false;
      progress.addEventListener('mousedown', function (e) {
        seeking = true; seekFromEvent(e);
      });
      window.addEventListener('mousemove', function (e) { if (seeking) seekFromEvent(e); });
      window.addEventListener('mouseup', function () { seeking = false; });
      progress.addEventListener('touchstart', function (e) { seekFromEvent(e); }, { passive: true });
      progress.addEventListener('touchmove', function (e) { seekFromEvent(e); }, { passive: true });
    }

    /* ---------- Volume ---------- */
    function updateVolumeUI() {
      var v = video.muted ? 0 : video.volume;
      if (volFill) volFill.style.height = Math.round(v * 100) + '%';
      playerEl.classList.toggle('is-muted', video.muted || video.volume === 0);
    }
    if (muteBtn) muteBtn.addEventListener('click', function () {
      if (video.muted || video.volume === 0) {
        video.muted = false;
        if (video.volume === 0) video.volume = 0.5;
      } else {
        video.muted = true;
      }
      updateVolumeUI();
    });
    if (volTrack) {
      var draggingVol = false;
      function setVolFromEvent(e) {
        var rect = volTrack.querySelector('.funnel-video-hero__volume-track').getBoundingClientRect();
        var y = (e.touches ? e.touches[0].clientY : e.clientY) - rect.top;
        var pct = 1 - Math.min(1, Math.max(0, y / rect.height));
        video.volume = pct;
        if (pct > 0 && video.muted) video.muted = false;
        if (pct === 0) video.muted = true;
        updateVolumeUI();
      }
      volTrack.addEventListener('mousedown', function (e) { draggingVol = true; setVolFromEvent(e); });
      window.addEventListener('mousemove', function (e) { if (draggingVol) setVolFromEvent(e); });
      window.addEventListener('mouseup', function () { draggingVol = false; });
      volTrack.addEventListener('touchstart', function (e) { setVolFromEvent(e); }, { passive: true });
      volTrack.addEventListener('touchmove', function (e) { setVolFromEvent(e); }, { passive: true });
    }
    video.addEventListener('volumechange', updateVolumeUI);
    updateVolumeUI();

    /* ---------- Settings menu (speed + quality) ---------- */
    function closeSettings() { if (settingsWrap) settingsWrap.classList.remove('is-open'); }
    if (settingsToggle && settingsWrap) {
      settingsToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        settingsWrap.classList.toggle('is-open');
      });
    }
    document.addEventListener('click', function (e) {
      if (settingsWrap && !settingsWrap.contains(e.target)) closeSettings();
    });

    if (speedOptions) {
      speedOptions.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-fvh-speed]');
        if (!btn) return;
        var rate = parseFloat(btn.getAttribute('data-fvh-speed'));
        video.playbackRate = rate;
        speedOptions.querySelectorAll('[data-fvh-speed]').forEach(function (b) { b.removeAttribute('data-active'); });
        btn.setAttribute('data-active', '');
      });
    }

    if (qualityOptions) {
      qualityOptions.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-fvh-quality]');
        if (!btn) return;
        var quality = btn.getAttribute('data-fvh-quality');
        qualityOptions.querySelectorAll('[data-fvh-quality]').forEach(function (b) { b.removeAttribute('data-active'); });
        btn.setAttribute('data-active', '');
        manualQuality = true;
        if (hlsInstance) setHlsQuality(quality);
        else switchQuality(quality);
      });
    }

    function switchQuality(quality) {
      var sources = Array.prototype.slice.call(video.querySelectorAll('[data-fvh-source]'));
      if (!sources.length) return;

      var target;
      if (quality === 'auto') {
        target = sources[0]; // first listed = highest (rendered first in reversed loop)
      } else {
        target = sources.find(function (s) { return s.getAttribute('data-quality') === quality; });
      }
      if (!target) return;

      var newSrc = target.getAttribute('src');
      if (newSrc === video.currentSrc) return;

      var wasPlaying = !video.paused;
      var wasTime = video.currentTime;

      video.src = newSrc;
      video.load();
      var onLoaded = function () {
        try { video.currentTime = wasTime; } catch (e) {}
        if (wasPlaying) video.play().catch(function () {});
        video.removeEventListener('loadedmetadata', onLoaded);
      };
      video.addEventListener('loadedmetadata', onLoaded);
    }

    /* ---------- Fullscreen ---------- */
    function isFs() {
      return document.fullscreenElement === playerEl ||
        document.webkitFullscreenElement === playerEl ||
        document.fullscreenElement === video ||
        document.webkitFullscreenElement === video ||
        !!video.webkitDisplayingFullscreen;
    }

    function fullscreenAvailable() {
      // Standard API (returns false in iframes without allow="fullscreen")
      if (typeof document.fullscreenEnabled !== 'undefined') {
        if (document.fullscreenEnabled) return true;
      }
      if (typeof document.webkitFullscreenEnabled !== 'undefined') {
        if (document.webkitFullscreenEnabled) return true;
      }
      // iOS Safari native video fullscreen (works even when standard API is blocked)
      if (typeof video.webkitEnterFullscreen === 'function') return true;
      return false;
    }

    function enterFs() {
      var attempts = [];
      // Try wrapper element first (gives us custom controls in fullscreen)
      if (playerEl.requestFullscreen) {
        attempts.push(function () { return playerEl.requestFullscreen(); });
      }
      if (playerEl.webkitRequestFullscreen) {
        attempts.push(function () { return playerEl.webkitRequestFullscreen(); });
      }
      // Then try the <video> element directly (falls back to native browser player)
      if (video.requestFullscreen) {
        attempts.push(function () { return video.requestFullscreen(); });
      }
      if (video.webkitRequestFullscreen) {
        attempts.push(function () { return video.webkitRequestFullscreen(); });
      }
      // iOS Safari: native video fullscreen (no Promise returned)
      if (typeof video.webkitEnterFullscreen === 'function') {
        attempts.push(function () {
          video.webkitEnterFullscreen();
          return Promise.resolve();
        });
      }

      (function tryNext(i) {
        if (i >= attempts.length) {
          console.warn('[funnel-video-hero] Fullscreen not available or all attempts rejected.');
          return;
        }
        var result;
        try { result = attempts[i](); }
        catch (e) { tryNext(i + 1); return; }
        if (result && typeof result.then === 'function') {
          result.then(function () { /* success */ }, function () { tryNext(i + 1); });
        }
      })(0);
    }

    function exitFs() {
      if (document.exitFullscreen) return document.exitFullscreen().catch(function () {});
      if (document.webkitExitFullscreen) return document.webkitExitFullscreen();
    }

    // Hide the fullscreen button if the API isn't available at all (e.g. iframe without allow="fullscreen")
    if (fsBtn && !fullscreenAvailable()) {
      fsBtn.style.display = 'none';
    }

    if (fsBtn) {
      fsBtn.addEventListener('click', function () {
        if (isFs()) exitFs(); else enterFs();
      });
    }
    document.addEventListener('fullscreenchange', function () {
      playerEl.classList.toggle('is-fullscreen', isFs());
    });
    document.addEventListener('webkitfullscreenchange', function () {
      playerEl.classList.toggle('is-fullscreen', isFs());
    });
    // iOS: also listen to the video element's native fullscreen events
    video.addEventListener('webkitbeginfullscreen', function () {
      playerEl.classList.add('is-fullscreen');
    });
    video.addEventListener('webkitendfullscreen', function () {
      playerEl.classList.remove('is-fullscreen');
    });

    /* ---------- Controls auto-hide on mouse activity ---------- */
    playerEl.addEventListener('mousemove', showControls);
    playerEl.addEventListener('mouseenter', showControls);
    playerEl.addEventListener('mouseleave', function () {
      if (!video.paused) playerEl.classList.remove('is-controls-visible');
    });
    playerEl.addEventListener('touchstart', showControls, { passive: true });

    /* ---------- Keyboard ---------- */
    playerEl.tabIndex = 0;
    playerEl.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'k') { e.preventDefault(); toggle(); }
      else if (e.key === 'm') { video.muted = !video.muted; updateVolumeUI(); }
      else if (e.key === 'f') { isFs() ? exitFs() : enterFs(); }
      else if (e.key === 'ArrowLeft') { video.currentTime = Math.max(0, video.currentTime - 5); }
      else if (e.key === 'ArrowRight') { video.currentTime = Math.min(video.duration || 0, video.currentTime + 5); }
    });

    /* ---------- CTA reveal ---------- */
    function showCta() {
      if (ctaShown || !cta) return;
      ctaShown = true;
      cta.classList.add('is-visible');
      cta.setAttribute('aria-hidden', 'false');
    }

    if (!cta) return;

    var trigger = (config.cta && config.cta.trigger) || 'time';
    var delayMs = ((config.cta && config.cta.delaySeconds) || 30) * 1000;
    var startOnFirstPlay = !!(config.cta && config.cta.startTimerOnFirstPlay);
    var exitMobileFallback = !!(config.cta && config.cta.exitIntentMobileFallback);

    if (trigger === 'disabled') {
      cta.style.display = 'none';
      return;
    }
    if (trigger === 'immediate') {
      requestAnimationFrame(showCta);
      return;
    }

    var ctaTimer = null;
    function scheduleCtaTimer() {
      if (ctaTimer || ctaShown) return;
      if (trigger !== 'time' && trigger !== 'both') return;
      ctaTimer = setTimeout(showCta, delayMs);
    }

    if (!startOnFirstPlay) {
      scheduleCtaTimer();
    }

    if (trigger === 'exit_intent' || trigger === 'both') {
      setupExitIntent(showCta, exitMobileFallback);
    }

    /* In design mode (theme editor), show CTA right away so it can be edited. */
    if (config.editor) {
      showCta();
    }
  }

  function setupExitIntent(onTrigger, mobileFallback) {
    var fired = false;
    function fire() { if (fired) return; fired = true; onTrigger(); }

    var isTouch = ('ontouchstart' in window) || (navigator.maxTouchPoints || 0) > 0;
    var isMobileViewport = window.innerWidth < 768;

    if (isTouch || isMobileViewport) {
      if (!mobileFallback) return;
      var lastY = window.scrollY || window.pageYOffset;
      var idleTimer = null;
      function onScroll() {
        var current = window.scrollY || window.pageYOffset;
        var dy = current - lastY;
        lastY = current;
        if (dy < -40) {
          if (idleTimer) clearTimeout(idleTimer);
          idleTimer = setTimeout(fire, 2500);
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
    } else {
      function onMouseLeave(e) {
        if (e.clientY <= 0 && (e.relatedTarget === null || e.relatedTarget === undefined)) fire();
      }
      document.documentElement.addEventListener('mouseleave', onMouseLeave);
    }
  }

  function initAll() {
    document.querySelectorAll('[data-funnel-video-hero]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    e.target.querySelectorAll('[data-funnel-video-hero]').forEach(init);
  });
})();
